import * as urlRegexSafe from 'url-regex-safe';

import { showErrorBar } from 'actions/errorBar';
import { updateVideoDescriptionState } from 'actions/shareVideo';
import { SHARE_VIDEO_DESCRIPTION_UPDATED } from 'constants/events';
import UpdateVideoDescription from 'creators/UpdateVideoDescription.gql';
import * as analytics from 'utilities/analytics';
import { getGraphQLClient } from 'utilities/graphql';

import { detectTimestamps } from './timestamps';

const updateVideoDescription = (
  dispatch,
  id,
  description,
  videoLength,
  isFirstUpdate
) => {
  const gqlClient = getGraphQLClient();

  const timestamps = detectTimestamps(description, videoLength);

  analytics.track(SHARE_VIDEO_DESCRIPTION_UPDATED, {
    length: description != null ? description.length : 0,
    includesTimestamp: timestamps.length !== 0,
    timestampCount: timestamps.length,
    isFirst: isFirstUpdate,
    hasLink: urlRegexSafe({ strict: true }).test(description),
  });

  return async () => {
    const { data } = await gqlClient.mutate({
      mutation: UpdateVideoDescription,
      variables: {
        id,
        description,
      },
      onError: () => {
        dispatch(showErrorBar('Failed to update description.'));
      },
    });

    if (data.updateVideoDescription.description) {
      dispatch(
        updateVideoDescriptionState(data.updateVideoDescription.description)
      );
    }
  };
};

export { updateVideoDescription };
